'use strict';

export default {
  micro: [60, 60],
  mini: [100, 100],
  thumb: [200, 200],
  trip: [280, 220],
  large: [320, 320],
  slideshow: [1000, 1000]
};



// WEBPACK FOOTER //
// ./app/src/constants/photo_sizes.js